<template>
  <div id="deliveryConfirm">
    <dd-header
      :isMenuView='false'
    />
    <dd-sitemap
      :pageKey="pageKey"
      :pageList="topForm.pageList"
    />
    <div class="container">
      <div class="title">
        <h1>事前現場調査内容確認画面</h1>
      </div>
      <section id="researchPlace">
        <h3>調査依頼場所</h3>
        <div>
          <div class="input_confirm3">
            <ul>
              <li>
                <span>施主名（物件名）</span>
                <span>{{resrchData.businessName}}</span>
              </li>
              <li>
                <span>調査物件名：</span>
                <span>{{resrchData.building}}</span>
              </li>
              <li>
                <span>郵便番号：</span>
                <span>{{resrchData.postcd}}</span>
              </li>
              <li>
                <span>住所：</span>
                <span>{{resrchData.state}} {{resrchData.city}} {{resrchData.street}}</span>
              </li>
              <li>
                <span>立会人氏名：</span>
                <span>{{resrchData.userLastName}} {{resrchData.userFirstName}}</span>
              </li>
              <li>
                <span>立会人氏名(カナ)：</span>
                <span>{{resrchData.userLastNameKana}} {{resrchData.userFirstNameKana}}</span>
              </li>
              <li>
                <span>立会人電話番号：</span>
                <span>{{resrchData.tel}}</span>
              </li>
              <li>
                <span>立会人への直接連絡：</span>
                <span>{{resrchData.contactFlag ? 'あり' : 'なし'}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section id="resrchCost">
        <h3>お見積り金額</h3>
        <div>
          <div class="input_confirm3">
            <ul>
              <li>
                <span>事前調査費用：</span>
                <span>{{formatPrice(values.price)}}</span>
              </li>
              <li>
                <div>消費税：</div>
                <div>{{formatPrice(values.tax)}}</div>
              </li>
              <li>
                <div>合計：</div>
                <div>{{formatPrice(values.totalPrice)}}</div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section id="resrchInfo">
        <h3>事前調査内容</h3>
        <div>
          <div class="sub_title">1.専有部分</div>
          <div class="input_confirm3">
            <ul>
              <li>
                <span>設置場所の採寸:</span>
                <span>{{values.priPosition}}</span>
              </li>
              <li>
                <span>設置場所の下地確認:</span>
                <span>{{values.priGround}}</span>
              </li>
              <li>
                <span>コンセント・PS等壁設置物確認:</span>
                <span>{{values.priPlug}}</span>
              </li>
              <li>
                <span>照明・自火報等天井設置物確認:</span>
                <span>{{values.priCeiling}}</span>
              </li>
              <li>
                <span>搬入経路の有効寸法確認:</span>
                <span>{{values.priCarryRoute}}</span>
              </li>
              <li>
                <span>その他確認事項:</span>
                <span>{{values.priConfComment}}</span>
              </li>
            </ul>
          </div>
          <div class="sub_title">2.共有部分</div>
          <div class="input_confirm3">
            <ul>
              <li>
                <span>トラック停車位置:</span>
                <span>{{values.pubTruckPark}}</span>
              </li>
              <li>
                <span>搬入経路:</span>
                <span>{{values.pubCarryRoute}}</span>
              </li>
              <li>
                <span>エレベーターサイズ:</span>
                <span>{{values.pubElevator}}</span>
              </li>
              <li>
                <span>搬入施工時の事前申請:</span>
                <span>{{values.pubRequest}}</span>
              </li>
              <li>
                <span>共有部養生の有無:</span>
                <span>{{values.pubCuring}}</span>
              </li>
              <li>
                <span>駐車場の有無:</span>
                <span>{{values.pubParking}}</span>
              </li>
              <li>
                <span>その他確認事項:</span>
                <span>{{values.pubConfComment}}</span>
              </li>
            </ul>
            <ul>
              <li>
                <span>その他コメント:</span>
                <span>{{values.otherComment}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section id="resrchDays">
        <h3>事前調査希望日</h3>
        <div>
          <div class="input_confirm3">
            <ul>
              <li>
                <span>第一希望日：</span>
                <span>{{values.pref1Val}} {{values.pref1TimeVal}}</span>
              </li>
              <li>
                <span>第二希望日：</span>
                <span>{{values.pref2Val}} {{values.pref2TimeVal}}</span>
              </li>
              <li>
                <span>その他日程調整希望：</span>
                <span>{{values.scheduleComment}}</span>
              </li>
              <li>
                <span>依頼人の立ち合い：</span>
                <span>{{values.observer}}</span>
              </li>
              <li>
                <span>調査先への入室方法：</span>
                <span>{{values.entranceComment}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section id="pre_confirm">
        <h3>確認事項</h3>
        <div>
          <div class="input_confirm">
            <div class="check_box">
              <input type="checkbox" id="confirmUseRule" v-model="confirmUseRule"/>
              <label for="confirmUseRule"><a class="link"><router-link class="link" to="/mmstyle/user/use-rule" target="_blank">利用規約</router-link></a>に同意して、購入する。</label>
            </div>
            <div class="check_box">
              <input type="checkbox" id="confirmItem" v-model="confirmItem"/>
              <label for="confirmItem">調査依頼内容に間違いがないことを確認しました。</label>
            </div>
            <div class="check_box">
              <input type="checkbox" id="confirmOrderDeliCancel" v-model="confirmOrderDeliCancel"/>
              <label for="confirmOrderDeliCancel" class="emphasis">注文後の事前調査希望日、及び事前現場調査先を変更することはできません。</label>
            </div>
          </div>
        </div>
      </section>
      <section id="form_button">
        <div class="control_btn_area">
          <div class="detail_btn2" @click="goBack()">〈〈&nbsp;&nbsp;&nbsp;戻る&nbsp;&nbsp;&nbsp;</div>
          <div :class="{detail_btn: true, disabled: isOrderDisable}" @click="confirm()">注文する</div>
        </div>
      </section>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

// import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import * as FormUtil from '../../utils/FormUtil'
// Module
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import SiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'BuildingResearchConfirm',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-sitemap': SiteMap,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'orderConfirm',
      topForm: {},
      priceData: {},
      resrchData: {},
      inputData: {},
      values: {
        postcd: 0,
        state: '',
        city: '',
        street: '',
        building: '',
        userFirstName: '',
        userLastName: '',
        userFirstNameKana: '',
        userLastNameKana: '',
        tel: 0,
        contactFlag: '',
        price: 0,
        tax: 0,
        totalPrice: 0,
        priPosition: '',
        priGround: '',
        priPlug: '',
        priCeiling: '',
        priCarryRoute: '',
        priConfComment: '',
        pubTruckPark: '',
        pubCarryRoute: '',
        pubElevator: '',
        pubRequest: '',
        pubCuring: '',
        pubParking: '',
        pubConfComment: '',
        // 画像添付一旦廃止
        // attchImgComment: '',
        // imgName: '',
        otherComment: '',
        allDaysFlg: false,
        scheduleComment: '',
        pref1Val: '',
        pref2Val: '',
        pref1TimeVal: '',
        pref2TimeVal: '',
        observer: 0,
        entranceComment: ''
      },
      form: {
        resrchId: '',
        corpId: '',
        userId: '',
        resrchPostcd: '',
        resrchState: '',
        resrchCity: '',
        resrchStreet: '',
        resrchBuilding: '',
        resrchUserFirstName: '',
        resrchUserLastName: '',
        resrchUserFirstNameKana: '',
        resrchUserLastNameKana: '',
        resrchTel: '',
        contactFlag: 0,
        // 以下事前現場調査入力
        resrchPriPositionFlg: false,
        resrchPriGroundFlg: false,
        resrchPriPlugFlg: false,
        resrchPriCeilingFlg: false,
        resrchPriCarryRouteFlg: false,
        resrchPriConfComment: '',
        resrchPubTruckParkFlg: false,
        resrchPubCarryRouteFlg: false,
        resrchPubElevatorFlg: false,
        resrchPubRequestFlg: false,
        resrchPubCuringFlg: false,
        resrchPubParkingFlg: false,
        resrchPubConfComment: '',
        resrchAttchImgComment: '',
        resrchOtherComment: '',
        resrchPref1: '',
        resrchPref1Type: 0,
        resrchPref2: '',
        resrchPref2Type: 0,
        resrchAllDaysFlg: false,
        resrchScheduleComment: '',
        resrchObserver: 0,
        resrchEntranceComment: ''
      },
      messages: {},
      // 確認項目
      confirmItem: false,
      confirmOrderDeliCancel: false,
      confirmUseRule: false
    }
  },
  computed: {
    isOrderDisable: function () {
      if (this.confirmItem && this.confirmOrderDeliCancel && this.confirmUseRule) {
        return false
      }
      return true
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    fetchData: function () {
      this.priceData = App.getLocalStorage(DC_STORAGE_KEY.PRICE_DATA)
      this.topForm = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      this.resrchData = App.getLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA)
      this.inputData = App.getLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
      // if (!this.topForm.colorCounter) {
      //   let colorCounter = {
      //     colorCounter: {id: '', name: null}
      //   }
      //   this.topForm = Object.assign(this.topForm, colorCounter)
      // }
      this.values = {
        // // 住所
        // postcd: this.resrchData.resrchPostcd,
        // state: this.resrchData.resrchState,
        // city: this.resrchData.resrchCity,
        // street: this.resrchData.resrchStreet,
        // building: this.resrchData.resrchBuilding,
        // userFirstName: this.resrchData.resrchUserFirstName,
        // userLastName: this.resrchData.resrchUserLastName,
        // userFirstNameKana: this.resrchData.resrchUserFirstNameKana,
        // userLastNameKana: this.resrchData.resrchUserLastNameKana,
        // tel: this.resrchData.resrchTel,
        // contactFlag: (this.resrchData.contactFlag === 1) ? 'あり' : 'なし',
        // 金額
        price: this.priceData.resrchPrice,
        tax: this.priceData.resrchPriceTax,
        totalPrice: this.priceData.resrchTotalPrice,
        // 専有部分
        priPosition: this.inputData.resrchPriPositionFlg ? 'あり' : 'なし',
        priGround: this.inputData.resrchPriGroundFlg ? 'あり' : 'なし',
        priPlug: this.inputData.resrchPriPlugFlg ? 'あり' : 'なし',
        priCeiling: this.inputData.resrchPriCeilingFlg ? 'あり' : 'なし',
        priCarryRoute: this.inputData.resrchPriCarryRouteFlg ? 'あり' : 'なし',
        priConfComment: this.inputData.resrchPriConfComment,
        // 共有部分
        pubTruckPark: this.inputData.resrchPubTruckParkFlg ? 'あり' : 'なし',
        pubCarryRoute: this.inputData.resrchPubCarryRouteFlg ? 'あり' : 'なし',
        pubElevator: this.inputData.resrchPubElevatorFlg ? 'あり' : 'なし',
        pubRequest: this.inputData.resrchPubRequestFlg ? 'あり' : 'なし',
        pubCuring: this.inputData.resrchPubCuringFlg ? 'あり' : 'なし',
        pubParking: this.inputData.resrchPubParkingFlg ? 'あり' : 'なし',
        pubConfComment: this.inputData.resrchPubConfComment,
        // その他コメントやフラグ
        otherComment: this.inputData.resrchOtherComment,
        allDaysFlg: this.inputData.resrchAllDaysFlg,
        // 画像添付一旦廃止
        // attchImgComment: this.inputData.resrchAttchImgComment,
        // imgName: (this.inputData.imgName === '選択されていません') ? '' : this.inputData.imgName,
        scheduleComment: this.inputData.resrchScheduleComment,
        observer: (this.inputData.resrchObserver === 1) ? 'あり' : 'なし',
        entranceComment: this.inputData.resrchEntranceComment
      }
    },
    getViewDate: function () {
      // 表示用フォーマット変数
      this.values.pref1Val = FormUtil.getViewDate(this.inputData.resrchPref1)
      this.values.pref2Val = FormUtil.getViewDate(this.inputData.resrchPref2)
    },
    getViewTime: function () {
      this.form.resrchPref1Type = this.inputData.resrchPref1Type
      switch (this.form.resrchPref1Type) {
        case 1:
          this.values.pref1TimeVal = 'AM( 9:00 ～ 13:00)'
          break
        case 2:
          this.values.pref1TimeVal = 'PM(13:00 ～ 17:00)'
          break
        default:
          this.values.pref1TimeVal = '指定なし'
          break
      }
      this.form.resrchPref2Type = this.inputData.resrchPref2Type
      switch (this.form.resrchPref2Type) {
        case 1:
          this.values.pref2TimeVal = 'AM( 9:00 ～ 13:00)'
          break
        case 2:
          this.values.pref2TimeVal = 'PM(13:00 ～ 17:00)'
          break
        default:
          this.values.pref2TimeVal = '指定なし'
          break
      }
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    confirm: function () {
      this.$refs.loadingModalRef.showModal(true)

      let payload = {
        // 現調入力
        businessName: this.resrchData.businessName,
        postcd: this.resrchData.postcd,
        state: this.resrchData.state,
        city: this.resrchData.city,
        street: this.resrchData.street,
        building: this.resrchData.building,
        userFirstName: this.resrchData.userFirstName,
        userLastName: this.resrchData.userLastName,
        userFirstNameKana: this.resrchData.userFirstNameKana,
        userLastNameKana: this.resrchData.userLastNameKana,
        tel: this.resrchData.tel,
        contactFlag: this.resrchData.contactFlag,
        // 事前現場調査項目
        resrchPriPositionFlg: this.inputData.resrchPriPositionFlg,
        resrchPriGroundFlg: this.inputData.resrchPriGroundFlg,
        resrchPriPlugFlg: this.inputData.resrchPriPlugFlg,
        resrchPriCeilingFlg: this.inputData.resrchPriCeilingFlg,
        resrchPriCarryRouteFlg: this.inputData.resrchPriCarryRouteFlg,
        resrchPriConfComment: this.inputData.resrchPriConfComment,
        resrchPubTruckParkFlg: this.inputData.resrchPubTruckParkFlg,
        resrchPubCarryRouteFlg: this.inputData.resrchPubCarryRouteFlg,
        resrchPubElevatorFlg: this.inputData.resrchPubElevatorFlg,
        resrchPubRequestFlg: this.inputData.resrchPubRequestFlg,
        resrchPubCuringFlg: this.inputData.resrchPubCuringFlg,
        resrchPubParkingFlg: this.inputData.resrchPubParkingFlg,
        resrchPubConfComment: this.inputData.resrchPubConfComment,
        // 画像添付一旦廃止コメント化
        // resrchAttchImgComment: this.inputData.resrchAttchImgComment,
        resrchOtherComment: this.inputData.resrchOtherComment,
        resrchPref1: this.inputData.resrchPref1,
        resrchPref1Type: this.inputData.resrchPref1Type,
        resrchPref2: this.inputData.resrchPref2,
        resrchPref2Type: this.inputData.resrchPref2Type,
        resrchScheduleComment: this.inputData.resrchScheduleComment,
        resrchObserver: (this.inputData.resrchObserver === 1),
        resrchEntranceComment: this.inputData.resrchEntranceComment,
        // 商品情報
        productName: this.topForm.fileName,
        colorDoorId: this.topForm.colorDoor ? this.topForm.colorDoor.id : null,
        colorBoxId: this.topForm.colorCabine ? this.topForm.colorCabine.id : null,
        colorCenterId: this.topForm.colorCounter ? this.topForm.colorCounter.id : null,
        width: this.topForm.topSpace.dcWidth,
        height: this.topForm.topSpace.dcHeight,
        depth: this.topForm.topSpace.dcDepth,
        fillerLeft: this.topForm.topSpace.dcBSize,
        fillerRight: this.topForm.topSpace.dcCSize,
        fillerCenter: this.topForm.topSpace.dcDSize,
        shelfCount: this.topForm.dcShelfCount,
        fillerCount: this.topForm.dcFillerCount,
        productCount: this.topForm.dcProductCount
      }
      axios.post(DC_URL.RESEARCH + '/confirm', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.$refs.loadingModalRef.showModal(false)
            App.showModal({
              title: 'エラー',
              messages: [response.data.errorMessage],
              messageType: 'error',
              onOk: () => {
                this.$router.push('/mmstyle/research/input')
              }
            })
          } else {
            this.$refs.loadingModalRef.showModal(false)
            this.$router.push('/mmstyle/research/complete')
          }
        }).catch(error => {
          App.showModal({
            messages: ['アクセスが集中しており、通信に失敗いたしました。恐れ入りますが、もう一度お試しください。'],
            messageType: 'error',
            onOk: () => {
            }
          })
          console.log(error)
          this.$refs.loadingModalRef.showModal(false)
        })
    }
  },
  created () {
    this.fetchData()
    this.getViewDate()
    this.getViewTime()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>
<style>
.note-size{
  font-size: 10px
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcBuildingResearchConfirm.vue